<script setup lang="ts">
const { t } = useTexts();
const { userDocument, userBirthdate, fetchUserProfile } = useUserData();

const IRPF_BASE_URL = 'https://irpf.blowbet.com.br/';
const BRAND_ID = 'AT';
const currentYear = String(new Date().getFullYear() - 1);

useSeo({
  title: t('income_report_external.title', { year: currentYear }),
});

const hasValidBirthdate = computed(() => {
  return !!userBirthdate.value && userBirthdate.value !== '0000-00-00';
});

const hasValidDocument = computed(() => {
  return !!userDocument.value;
});

const hasRequiredData = computed(() => {
  return hasValidDocument.value && hasValidBirthdate.value;
});

const irpfUrl = computed(() => {
  if (!hasRequiredData.value) return '';

  const params = new URLSearchParams({
    brand_id: BRAND_ID,
    client_id: userDocument.value,
    birth_date: userBirthdate.value,
  });

  return `${IRPF_BASE_URL}?${params.toString()}`;
});

function handleDownload() {
  if (!hasRequiredData.value || !irpfUrl.value) return;
  window.open(irpfUrl.value, '_blank');
}

onBeforeMount(() => {
  if (!hasValidDocument.value || !hasValidBirthdate.value) {
    fetchUserProfile({ force: true });
  }
});
</script>

<template>
  <UserAccountPageLayout
    on-back="user-account"
    :title="$t('income_report_external.title', { year: currentYear })"
  >
    <UserBox>
      <div class="flex flex-col gap-4">
        <div class="flex flex-col gap-2">
          <h2 class="text-base font-semibold text-texts">
            {{ $t('income_report_external.heading') }}
          </h2>
          <p class="text-sm text-texts/70">
            {{
              $t('income_report_external.description', { year: currentYear })
            }}
          </p>
        </div>

        <div class="flex flex-col gap-3 w-full max-w-[400px]">
          <div
            v-if="!hasRequiredData"
            class="flex flex-col gap-2 p-4 rounded-md bg-error/10 border border-error/20"
          >
            <p class="text-sm text-error font-medium">
              {{ $t('income_report_external.incomplete_data') }}
            </p>
          </div>

          <button
            class="py-3 px-4 rounded-md w-full text-sm flex items-center justify-center gap-2 bg-primary text-button-text font-bold disabled:opacity-50 disabled:cursor-not-allowed"
            :disabled="!hasRequiredData"
            @click="handleDownload"
          >
            <NuxtIcon
              filled
              name="document"
            />
            {{ $t('income_report_external.download_button') }}
          </button>
        </div>
      </div>
    </UserBox>
  </UserAccountPageLayout>
</template>
